import type { LibraryState } from './types'

export const defaultValues: LibraryState = {
  gateway: process.env.NEXT_GATEWAY_NAME || '',
  gatewayPath: process.env.NEXT_PUBLIC_GATEWAY_URL?.trim() ?? '',
  gatewayPort: process.env.NEXT_PUBLIC_GATEWAY_PORT?.trim() || '8080',
  isSecured: (process.env.NEXT_PUBLIC_GATEWAY_SECURED?.trim() ?? '') === 'true',
  guid: '',
  projectName: '',
  registry: '',
  gsmuEndpoint: '',
  gatewayWsPort: '',
  gatewayMcpPort: '',
  results: {},
  logs: {},
  libraries: {},
  loading: false,
}
